import { useState } from "react";
import { useDispatch } from "react-redux";
import { getPdb } from "../../api/ApiService";
import { PdbEndpoint } from "../../config/pdbEndpoint";
import { ProductType } from "../../shared/enums/ProductType";
import { action } from "../../store/action";
import { useProductByType } from "../../store/hooks/useProductByType";
import { ProductData } from "../../store/interfaces/productData";

export const usePdbData = () => {
  const dispatch = useDispatch();
  const [isPdbDataLoaded, setIsPdbDataLoaded] = useState<boolean>(false);
  const tiltrotatorsData = useProductByType(
    ProductType.Rototilts
  ) as ProductData;
  const upperBracketsData = useProductByType(
    ProductType.UpperBrackets
  ) as ProductData;
  const lowerBracketsData = useProductByType(
    ProductType.LowerBrackets
  ) as ProductData;
  const machineFixingsData = useProductByType(
    ProductType.MachineFixings
  ) as ProductData;
  const asphaltCuttersData = useProductByType(
    ProductType.AsphaltCutters
  ) as ProductData;
  const bucketsData = useProductByType(ProductType.Buckets) as ProductData;
  const compactorsData = useProductByType(
    ProductType.Compactors
  ) as ProductData;
  const gradingBeamsData = useProductByType(
    ProductType.GradingBeams
  ) as ProductData;
  const grapplesData = useProductByType(ProductType.Grapples) as ProductData;
  const grappleModulesData = useProductByType(
    ProductType.GrappleModules
  ) as ProductData;
  const railGrapplesData = useProductByType(
    ProductType.RailGrapples
  ) as ProductData;
  const rippersData = useProductByType(ProductType.Rippers) as ProductData;

  const loadPdbData = () => {
    setIsPdbDataLoaded(true);

    if (!tiltrotatorsData) {
      getPdb(PdbEndpoint.Tiltrotator).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "rototilts",
          })
        );
      });
    }

    if (!upperBracketsData) {
      getPdb(PdbEndpoint.UpperBrackets).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "upperbrackets",
          })
        );
      });
    }

    if (!lowerBracketsData) {
      getPdb(PdbEndpoint.LowerBrackets).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "lowerbrackets",
          })
        );
      });
    }

    if (!machineFixingsData) {
      getPdb(PdbEndpoint.MachineFixings).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "machinefixings",
          })
        );
      });
    }

    if (!asphaltCuttersData) {
      getPdb(PdbEndpoint.AsphaltCutters).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "asphaltcutters",
          })
        );
      });
    }

    if (!bucketsData) {
      getPdb(PdbEndpoint.Buckets).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "buckets",
          })
        );
      });
    }

    if (!compactorsData) {
      getPdb(PdbEndpoint.Compactors).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "compactors",
          })
        );
      });
    }

    if (!gradingBeamsData) {
      getPdb(PdbEndpoint.GradingBeams).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "gradingbeams",
          })
        );
      });
    }

    if (!grapplesData) {
      getPdb(PdbEndpoint.Grapples).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "grapples",
          })
        );
      });
    }

    if (!grappleModulesData) {
      getPdb(PdbEndpoint.GrappleModules).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "grapplemodules",
          })
        );
      });
    }

    if (!railGrapplesData) {
      getPdb(PdbEndpoint.RailGrapples).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "railgrapples",
          })
        );
      });
    }

    if (!rippersData) {
      getPdb(PdbEndpoint.Rippers).then((result) => {
        dispatch(
          action.saveProducts({
            result,
            type: "rippers",
          })
        );
      });
    }
  };

  return {
    isPdbDataLoaded,
    loadPdbData,
  };
};
